<template>
    <b-modal
        id="modal-scaledataselector"
        ref="modal"
        size="xl"
        :title="this.formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
        @change="change"
    >
        <b-card @submit.stop.prevent="handleSubmit">
            <div>
                <b-alert
                    v-model="showDismissibleAlert"
                    variant="danger"
                    dismissible
                >
                    {{ alertText }}
                </b-alert>

                <b-table
                    striped
                    responsive
                    :fields="visibleFields"
                    :items="displayList"
                    selectable
                    ref="prodTable"
                    @row-selected="onRowSelected"
                >
                    <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                        </template>
                        <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                        </template>
                    </template>
                </b-table>
            </div>
        </b-card>
    </b-modal>
</template>
<script>
import DateHelper from '../../models/DateHelper';
import { loadList, loadItem } from '../../models/DataHelper';
export default {
    name: 'ScaleDataSelector',
    data: function () {
        return {
            showDismissibleAlert: false,
            alertText: '',
            selected: [],
            forcerefresh: true,
            datum: new Date(),
            displayList: [],
            selectedObject: null
        };
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        location: {
            type: String
        },
        baseDate: {
            type: Date
        }
    },
    watch: {},
    components: {},
    computed: {
        formtitle() {
            return this.title;
        },
        erisselected() {
            return this.selected.length > 1;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'selected', label: ' ', sortable: false, visible: true },
                { key: 'actions', label: ' ', visible: false },
                {
                    key: 'geregistreerd',
                    label: this.$t('com_tijdstip', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    formatter: (value, key, item) => {
                        const temp = DateHelper.convertedToDate(
                            item.geregistreerd,
                            true
                        );
                        return temp;
                    }
                },
                {
                    key: 'productie',
                    label: this.$t('com_batch', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'aantal',
                    label: this.$t('com_amount', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    tdClass: (value) =>
                        value < 0 ? 'text-danger' : 'text-success'
                },
                {
                    key: 'gewichtNetto',
                    label: this.$t('prod_netto', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'gewichtBruto',
                    label: this.$t('prod_bruto', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'gewichtTarra',
                    label: this.$t('prod_tarra', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'eenheid',
                    label: this.$t('com_unit', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'status',
                    label: this.$t('com_status', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    tdClass: (value) =>
                        value > 1 ? 'text-danger' : 'text-success'
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        hide() {
            this.$emit('hide');
        },
        checkFormValidity() {
            if (this.alertText.length > 1) return true;
            let valid = true;
            let tekst = '';
            if (this.selected.length === 0) {
                tekst = this.$t('com_geen_data', { ns: 'common' });
            } else {
                const dagen = DateHelper.dateDiffinDays(
                    this.baseDate,
                    this.selected[0].geregistreerd
                );
                if (dagen > 1)
                    tekst += this.$t('prod_diffregdatebookdate', {
                        ns: 'production',
                        val: Math.round(dagen)
                    });
            }
            if (tekst.length > 2) this.showAlert(tekst);
            valid = !tekst;
            return valid;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        handleSubmit() {
            if (!this.checkFormValidity()) {
                return;
            }
            // Hide the modal manually
            this.$nextTick(() => {
                const sel = this.selected[0];
                this.$emit('input', sel);
                this.$bvModal.hide('modal-scaledataselector');
            });
        },
        async findScaleDataNotUsed() {
            this.clearSelected();
            const o = DateHelper.determineVanTotUTC(null, -30, 0);
            const selectionData = { from: o.van, until: o.tot };
            let lijst = [];
            switch (this.location) {
                case 'NP': {
                    lijst = await loadItem(
                        'outbrine/loadOutbrineDataIgnored',
                        selectionData,
                        this.$t
                    );
                    break;
                }
                default:
                    lijst = await loadItem(
                        'production/loadInbrineDataIgnored',
                        selectionData,
                        this.$t
                    );
            }
            this.displayList = lijst;
        },
        onRowSelected(items) {
            this.selected = items;
        },
        clearSelected() {
            this.selectedObject = null;
            if (this.$refs.prodTable) this.$refs.prodTable.clearSelected();
        },
        change(visible) {
            this.$emit('change', visible);
        }
    },
    mounted() {},
    async created() {
        await this.findScaleDataNotUsed();
    }
};
</script>

<style scoped>
::v-deep .table > tbody > tr.b-table-row-selected,
::v-deep .table > tbody > tr.b-table-row-selected > td,
::v-deep .table > tbody > tr.b-table-row-selected > th {
    background-color: #00a1de;
    color: ghostwhite !important;
}
.overflow-class /deep/ .dropdown-menu {
    max-height: 200px;
    overflow-y: auto;
}
</style>

